import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ListFilter } from '../show-menu/models/MenuModel';
import { CheckOutResult } from 'src/app/shared/check-out/CheckOut.models';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResAnonymousService {
  checkOutDone = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }


  GetRestaurantShortDetails(id: any) {
    return this.http.get(`${environment.apiUrl}/Restaurant/GetRestaurantShortDetails?id=${id}`);
  }
  getMenuSections(data: any) {
    return this.http.post(`${environment.apiUrl}/ResAnonymous/ResAnonymousGetMenuSections`, data);
  }
  getMenuItems(filter: ListFilter) {
    return this.http.post(`${environment.apiUrl}/ResAnonymous/ResAnonymousGetMenuItems`, filter);
  }
  getMenuItemById(MenuItemId: any) {
    return this.http.get(`${environment.apiUrl}/ResAnonymous/ResAnonymousGetMenuItemById?MenuItemId=${MenuItemId}`);
  }
  ResAnonymousTakeawayGetCheckoutId(data: any) {
    return this.http.post<any>(`${environment.apiUrl}/ResAnonymous/ResAnonymousTakeawayGetCheckoutId`, data);
  }
  ResAnonymousTakeawayGetCheckoutStatus(CheckoutId: any) {
    return this.http.get<CheckOutResult>(`${environment.apiUrl}/ResAnonymous/ResAnonymousTakeawayGetCheckoutStatus?CheckoutId=${CheckoutId}`);
  }
  ResAnonymousCashonDeliverOrder(data: any) {
    return this.http.post<any>(`${environment.apiUrl}/ResAnonymous/ResAnonymousCashonDeliverOrder`, data);
  }

  // Client payment
  ValidateAnonymousCheckOutId(checkoutId: string, type: string) {
    return this.http.get(`${environment.apiUrl}/ResAnonymous/ValidateAnonymousCheckOutId?checkOutId=${checkoutId}&type=${type}`);
  }

  ResAnonymousTakeawayOrderStatus(orderId: string) {
    return this.http.get(`${environment.apiUrl}/ResAnonymous/ResAnonymousTakeawayOrderStatus?orderId=${orderId}`);
  }

  ResAnonymousCheckVoucherDiscount(data: any) {
    return this.http.post(`${environment.apiUrl}/ResAnonymous/ResAnonymousCheckVoucherDiscount`, data);
  }

  ResTakeAwayOrderPermissions(restaurantId: number) {
    return this.http.get(`${environment.apiUrl}/ResReservationOrderTakeaway/ResTakeAwayOrderPermissions?restaurantId=${restaurantId}`);
  }

  ResAnonymousTakeawayPage(id: any) {
    return this.http.get(`${environment.apiUrl}/ResAnonymous/ResAnonymousTakeawayPage?restaurantId=${id}`);
  }
}
